import React from 'react';
import {
  Row,
  Col,
  Popover,
  Input,
} from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { withTranslation } from 'react-i18next';
import { FixedSizeList as List } from 'react-window';
import { connect } from 'react-redux';

import BorderlessButton from '../../common/buttons/BorderlessButton';
import OnTraccrCheckbox from '../../common/inputs/OnTraccrCheckbox';
import OnTraccrSwitch from '../../common/inputs/OnTraccrSwitch';
import Colors from '../../constants/Colors';

class ReportFilterCard extends React.Component {
  constructor(props) {
    super(props);
    const {
      content = [],
      selected,
    } = this.props;
    this.state = {
      data: content,
      checked: new Set(selected ?? content),
    };
  }

  componentDidUpdate(prevProps) {
    const {
      content: prevContent,
      selected: prevSelected,
    } = prevProps;
    const {
      content,
      selected,
    } = this.props;
    const actualSelected = selected ?? content;
    const prevActualSelected = prevSelected ?? prevContent;
    if (actualSelected !== prevActualSelected) {
      const {
        checked: oldChecked,
      } = this.state;
      const newState = {
        data: content,
      };
      const prevArray = Array.from(prevActualSelected);
      if (
        prevArray?.every((item) => oldChecked?.has(item))
        && oldChecked.size === prevArray?.length
      ) {
        // If user hasnt modified the checked
        // And new item is added we auto check it
        newState.checked = new Set(actualSelected);
      }
      this.setState(newState);
    }
  }

  generateMenu() {
    const {
      content = [],
      onFilterToggle,
      t,
      title,
      showActiveUsersOnly,
      onActiveUsersToggle,
    } = this.props;
    const {
      data = [],
      checked,
    } = this.state;
    const isEmployeeFilter = title === 'Employee';

    return (
      <div style={{width: 350}}>
        <Row>
          <Col>
            <Input.Search
              className='searchbar'
              placeholder="Search"
              onChange={(e) => {
                const {
                  target: {
                    value,
                  } = {}
                } = e;
                if(!value) {
                  return this.setState({ data: content });
                }
                this.setState({
                  data: content.filter(item => item.toLowerCase().includes(value.toLowerCase())),
                });
              }}
              allowClear
              style={{
                marginBottom:10,
                width:150,
              }}
            />
          </Col>
          <Col>
            <BorderlessButton
              title='Clear All'
              onClick={() => {
                const checked = new Set();
                onFilterToggle(checked)
                this.setState({
                  checked,
                });
            }}
            />
          </Col>
          <Col>
            <BorderlessButton
              title='Select All'
              onClick={() => {
                const checked = new Set(content);
                onFilterToggle(checked)
                this.setState({
                  checked,
                })
              }}
            />
          </Col>
          {isEmployeeFilter && (
            <Col>
              <OnTraccrSwitch
                title='Show Active Users Only'
                value={showActiveUsersOnly}
                onChange={onActiveUsersToggle}
                containerStyle={{
                  marginBottom: 20,
                }}
                textStyle={{
                  fontFamily: 'roboto-light',
                }}
              />
            </Col>
          )}
        </Row>
        <List
          height={Math.min(data.length * 25, 300)}
          itemCount={data.length}
          itemSize={25}
          width={350}
        >
         {
          ({ index, style }) => {
            const item = data[index];
            return (
              <Row gutter={8} align='middle' key={item + index} style={style}>
                <Col>
                  <OnTraccrCheckbox
                    value={checked.has(item)}
                    onChange={(e) => {
                      const newChecked = new Set(checked);
                      if(e) {
                        newChecked.add(item);
                      } else {
                        newChecked.delete(item);
                      }
                      this.setState({
                        checked:newChecked,
                      });
                      onFilterToggle(newChecked);
                    }}
                    label={t(item)}
                    textStyle={{
                      marginBottom: 0,
                      maxWidth: 300,
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                    }}
                    checkboxStyle={{
                      maxWidth: 300,
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                    }}
                  />
                </Col>
              </Row>
            );
          }
         }
        </List>
      </div>
    );
  }

  renderContent() {
    const { content = [], title, settings } = this.props;

    const color = settings?.settings?.uxRedesignPt1 ? Colors.REDESIGN_PRIMARY_TEXT : 'black';

    return content.length > 0
      ? (
        <Popover
          content={this.generateMenu()}
          trigger='click'
          placement='bottomRight'
          getPopupContainer={node => node.parentNode}
        >
          <BorderlessButton
            title={title}
            style={{
              marginBottom: 0,
              padding: 0,
              fontSize: 12,
              height: 22,
              color,
            }}
            iconNode={<DownOutlined/>}
          />
        </Popover>
      ) : (
        <span style={{ fontSize: 12, color }}>{title}</span>
      );
  }
  render() {
    const {
      onCheckChanged,
      checkDisabled,
      checked = true,
      hoverHelp = null,
    } = this.props;
    return <Row
      style={{
        borderRadius: 6,
        borderWidth: 1,
        borderColor: 'gray',
        borderStyle: 'solid',
        padding: 5,
        marginTop: 20,
        backgroundColor: 'white',
      }}
      align="middle"
      gutter={4}
    >
      <Col>
        <OnTraccrCheckbox
          disabled={checkDisabled}
          onChange={onCheckChanged}
          value={checked}
          checkboxStyle={{ marginRight: 0 }}
        />
      </Col>
      <Col>
        {this.renderContent()}
      </Col>
      {hoverHelp && (
        <Col>
          {hoverHelp}
        </Col>
      )}
    </Row>;
  }
}

export default withTranslation()(connect((state, ownProps) => ({
  ...ownProps,
  settings: state.settings.company,
}))(ReportFilterCard));
